import React from 'react'
import cx from 'classnames'

import Participant from './Participant'
import {
  useSelectedParticipant,
  useMainParticipant,
  useParticipants,
  useMediaContext,
  useScreenShareParticipant
} from '@gopeerproject/web-kit'

const ParticipantList = () => {
  const { room } = useMediaContext()
  const localParticipant = room?.localParticipant
  const participants = useParticipants()
  const [selectedParticipant, setSelectedParticipant] = useSelectedParticipant()
  const screenShareParticipant = useScreenShareParticipant()
  const mainParticipant = useMainParticipant()
  const isRemoteParticipantScreenSharing =
    screenShareParticipant && screenShareParticipant !== localParticipant

  if (participants.length === 0) return null

  return (
    <div
      className={cx('gp-Media-participantList', {
        'is-screenShared': isRemoteParticipantScreenSharing
      })}
    >
      <Participant participant={localParticipant} isLocalParticipant={true} />
      {participants.map((participant) => {
        const isSelected = participant === selectedParticipant
        const hideParticipant =
          participant === mainParticipant &&
          participant !== screenShareParticipant &&
          !isSelected

        return (
          <Participant
            key={participant.sid}
            participant={participant}
            isSelected={participant === selectedParticipant}
            onClick={() => setSelectedParticipant(participant)}
            hideParticipant={hideParticipant}
          />
        )
      })}
    </div>
  )
}

export default ParticipantList
